module.exports = __webpack_public_path__ + "img/jebsen.c833fbd0.png";